import CloneError from "./CloneError.mjs";
/**
 * @public
 */
class ShallowCloneError extends CloneError {}
export default ShallowCloneError;